import React, { useState } from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import style from "./GalleryItem.module.css";
import cx from "classnames";
import {
  GALLERY_ICON_MAP,
  GALLERY_TYPES,
} from "ui/pages/TemplatePreview/constants";
import ExlyImage from "common/Components/ExlyImage";
import classnames from "classnames";

const GalleryItem = React.memo((props) => {
  const {
    item,
    isDragging,
    innerRef,
    children,
    someItemBeingDragged,
    handleEdit,
    handleDelete,
    disableAllEdits,
    // TODO: update here as well after figuring out what draggableProvided.draggableProps are
    //  and remove `rest`
    ...rest
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    if (disableAllEdits) return;
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={style.galleryCardOuter} ref={innerRef} {...rest}>
      <div
        className={classnames(
          style.galleryCard,
          isDragging && style.dragging,
          someItemBeingDragged && style.someItemBeingDragged
        )}
      >
        <div className={style.previewImageContainer}>
          {[GALLERY_TYPES.IMAGE, GALLERY_TYPES.PHOTO].includes(item?.type) ? (
            <ExlyImage
              src={item?.media}
              loading="lazy"
              alt="img"
              width="125px"
              height="70px"
              className={style.previewImage}
            />
          ) : null}
          {item?.type === GALLERY_TYPES.VIDEO ? (
            <div
              className={cx(
                style.previewVideo,
                disableAllEdits && style.disabled
              )}
              onClick={() => {
                if (disableAllEdits) return;
                handleEdit(true);
              }}
              title="Open video preview"
            >
              <PlayArrowIcon fontSize="large" />
            </div>
          ) : null}
        </div>
        <div className={style.content}>
          <div>
            <div
              className={`${style.caption} ${
                item?.caption ? "" : style.emptyCaption
              }`}
            >
              {item?.caption || <>&lt;No Caption&gt;</>}
            </div>
            <div className={style.contentType}>
              {GALLERY_ICON_MAP?.[item?.type]?.()}&nbsp;
              {item?.type}
            </div>
          </div>
          <div
            className={cx(style.optionsMenu, disableAllEdits && style.disabled)}
            onClick={handleOpen}
          >
            <MoreVertIcon />
          </div>
          {children}
        </div>
      </div>
      <Menu
        id={`gallery-menu-${item?.uuid}`}
        anchorEl={anchorEl}
        keepMounted
        open={!!anchorEl}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem
          onClick={() => {
            handleEdit();
            handleClose();
          }}
        >
          <EditIcon />
          &nbsp; Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleDelete();
            handleClose();
          }}
        >
          <DeleteIcon />
          &nbsp; Delete
        </MenuItem>
      </Menu>
    </div>
  );
});
GalleryItem.displayName = "Gallery Item";

export default GalleryItem;
